module.exports = __webpack_public_path__ + "img/fifa_1.29340cc4.png";